/* Lalumi FX: finishes free-shipping UI for NON shop-currency carts (e.g. USD).
   Liquid has no exchange rate, so snippets output CAD rule values (data-threshold-shop, data-rate-shop)
   and this converts them with window.Shopify.currency.rate, the storefront's own conversion rate.
   The threshold is rounded UP to the cent so it never claims "unlocked" early.
   Shop-currency (CAD) visitors are fully server-rendered; this script does nothing for them.
   Re-runs automatically when the cart drawer re-renders (MutationObserver). */
(function () {
  var cur = (window.Shopify && window.Shopify.currency) || {};
  var rate = parseFloat(cur.rate);
  var code = cur.active;
  if (!(rate > 0) || !code) return;

  function fmt(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function fmtShort(cents) {
    return cents % 100 === 0 ? fmt(cents).replace(/\.00(?=\D*$)/, '') : fmt(cents);
  }
  function threshold(el) {
    return Math.ceil(parseInt(el.getAttribute('data-threshold-shop'), 10) * rate);
  }

  function claims(root) {
    root.querySelectorAll('[data-lalumi-fx-claim]:not([data-fx-done])').forEach(function (el) {
      el.setAttribute('data-fx-done', '');
      var price = parseInt(el.getAttribute('data-price'), 10);
      if (!(price >= threshold(el))) return;
      var rs = el.getAttribute('data-rate-shop');
      var ship = rs ? Math.round(parseInt(rs, 10) * rate) : null;
      var save = parseInt(el.getAttribute('data-save'), 10) || 0;
      var txt;
      if (ship != null) {
        txt = save > 0 ? 'Save ' + fmtShort(save + ship) + ' incl. free shipping' : 'Free shipping included (a ' + fmt(ship) + ' value)';
      } else {
        txt = save > 0 ? 'Save ' + fmtShort(save) + ' + free shipping' : 'Free shipping included';
      }
      el.textContent = txt;
      el.hidden = false;
    });
  }

  function bars(root) {
    root.querySelectorAll('[data-lalumi-fx-bar]:not([data-fx-done])').forEach(function (bar) {
      bar.setAttribute('data-fx-done', '');
      var cart = parseInt(bar.getAttribute('data-cart'), 10) || 0;
      if (cart <= 0) return;
      var t = threshold(bar);
      var gap = t - cart;
      var msg = bar.querySelector('.lalumi-freeship__msg');
      var track = bar.querySelector('.lalumi-freeship__track');
      if (gap <= 0) {
        bar.classList.add('lalumi-freeship--unlocked');
        msg.innerHTML = '<span class="lalumi-freeship__check" aria-hidden="true">\u2713</span> You\u2019ve unlocked free shipping';
        if (track) track.hidden = true;
        return;
      }
      msg.textContent = 'You\u2019re ' + fmt(gap) + ' away from free shipping';
      if (track) {
        track.hidden = false;
        var fill = track.querySelector('.lalumi-freeship__fill');
        if (fill) fill.style.width = Math.floor((cart * 100) / t) + '%';
      }
      var tpl = bar.querySelector('template.lalumi-freeship__candidates');
      if (!tpl || bar.querySelector(':scope > .lalumi-freeship__nudge')) return;
      var shown = {};
      document.querySelectorAll('cart-drawer .lalumi-cart-upsell__item[data-handle]').forEach(function (li) {
        shown[li.getAttribute('data-handle')] = 1;
      });
      var above = null, below = null;
      tpl.content.querySelectorAll('.lalumi-freeship__nudge').forEach(function (row) {
        if (shown[row.getAttribute('data-handle')]) return;
        var p = parseInt(row.getAttribute('data-price'), 10);
        if (p >= gap) { if (!above || p < above.p) above = { p: p, row: row }; }
        else if (!below || p > below.p) below = { p: p, row: row };
      });
      var pick = above || below;
      if (!pick) return;
      var node = pick.row.cloneNode(true);
      var label = node.querySelector('[data-fx-label]');
      if (label) label.textContent = pick.p >= gap ? 'unlocks free shipping' : 'gets you closer';
      bar.appendChild(node);
    });
  }

  function run() { claims(document); bars(document); }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { queue(); return; } }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
